import { ceTaskboardActions } from './ceTaskboardActionCreator';

const initialState = {
  isLoading: false,
  isLoaded: false,
  taskboardData: [],
  error: null,
  pageNumber: 0,
  pageSize: 20,
  totalElements: 0,
  pendingTaskCount: {},
  poDetails: [],
  isPoDetailsLoading: false,
  filters: {
    deliveryType: 'APPOINTMENT',
    statuses: 'PENDING'
  },
  bulkApproveOrRejectInProgress: false
};

const ceTaskboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case ceTaskboardActions.GET_PO_DETAILS:
    case ceTaskboardActions.DISABLE_SUBMIT_BUTTON:
    case ceTaskboardActions.GET_TASKBOARD_DATA: {
      return Object.assign({}, state, action.payload);
    }
    case ceTaskboardActions.UPDATE_PAGE_NUMBER: {
      return Object.assign({}, state, { pageNumber: action.payload });
    }
    case ceTaskboardActions.UPDATE_PENDING_TASK_COUNT: {
      return Object.assign({}, state, { pendingTaskCount: action.payload });
    }
    case ceTaskboardActions.UPDATE_FILTER: {
      return Object.assign({}, state, {
        filters: Object.assign(state.filters, { [action.key]: action.payload })
      });
    }
    case ceTaskboardActions.GET_FC_NAME_HASH: {
      if ('fcNameHash' in action.payload) {
        return Object.assign({}, state, action.payload);
      }
      return Object.assign({}, state, {
        fcNameHash: {
          ...state.fcNameHash,
          [action.payload.client]: action.payload.fcNameList.map(fc => {
            return { key: fc, val: fc };
          })
        },
        isFcNameHashLoading: action.payload.isFcNameHashLoading
      });
    }
    case ceTaskboardActions.SET_BULK_APPROVE_OR_REJECT_PROGRESS: {
      return Object.assign({}, state, {
        bulkApproveOrRejectInProgress: action.payload
      });
    }
    case ceTaskboardActions.UPDATE_TABLE: {
      return Object.assign({}, state, { taskboardData: action.payload });
    }
    default: {
      return state;
    }
  }
};

export default ceTaskboardReducer;
